import dayjs from "dayjs";
import { BillingType, IPhase } from "../interfaces/phase.interface";

function parseDate(dateStr: string | Date): Date {
  return new Date(dateStr);
}

export function calculatePhaseSum(phases: IPhase<BillingType>[]): number {
  let totalPrice = 0;

  const now = new Date();

  phases.forEach((phase) => {
    let fromDate: Date;
    let toDate: Date;

    if (typeof phase.duration?.from === "string") {
      fromDate = parseDate(phase.duration.from);
    } else {
      throw Error("From Date is not a date!");
    }

    if (typeof phase.duration.to === "string") {
      toDate = parseDate(phase.duration.to);
    } else {
      throw Error("To Date is not a date!");
    }

    if (fromDate <= now && toDate >= now) {
      const activeDays =
        Math.ceil(
          (now.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)
        ) + 1;

      // Calculate the total sum for product items based on their billing frequency
      phase.product_items.forEach((item) => {
        let itemTotal = 0;

        switch (phase.invoice.unit) {
          case BillingType.Day:
            itemTotal = item.netto_price * (item.quantity || 1);
            break;
          case BillingType.Week:
            itemTotal = item.netto_price * (item.quantity || 1);
            break;
          case BillingType.Month:
            itemTotal = item.netto_price * (item.quantity || 1);
            //   Math.floor(activeDays / (item.billing_frequency.value * 30));
            break;
          case BillingType.Year:
            itemTotal =
              item.netto_price *
              (item.quantity || 1) *
              Math.floor(activeDays / (phase.invoice.value * 365));
            break;
          default:
            break;
        }
        // Add itemTotal to totalPrice
        totalPrice += itemTotal;
      });
    }
  });
  return totalPrice;
}

export function getFirstAndLastDates(data: IPhase[]): { firstDate; lastDate } {
  let firstDate: string | Date | null = null;
  let lastDate: string | Date | null = null;

  data?.forEach((entry) => {
    const fromDateString = entry.duration?.from as string;
    const toDateString = entry.duration?.to as string;

    // Convert 'forever' to a large future date

    // Convert to Date objects
    const fromDate = new Date(fromDateString);
    const toDate = new Date(toDateString);

    // Update first and last dates
    if (!firstDate || fromDate < firstDate) {
      firstDate = fromDate;
    }
    if (toDateString == "forever") {
      lastDate = toDateString;
    }
    if (!lastDate || toDate > lastDate) {
      lastDate = toDate;
    }
  });
  return { firstDate, lastDate };
}

export function calculateStartandEndDate({
  unit,
  value,
  obj,
  startDate,
}: {
  unit: BillingType;
  value: number;
  obj: any;
  startDate: dayjs.Dayjs;
}): string {
  if (unit == BillingType.Start) {
    obj = startDate.format("YYYY-MM-DD");
  } else if (unit === BillingType.Day) {
    obj = startDate.add(value, "days").format("YYYY-MM-DD");
  } else if (unit === BillingType.Week) {
    obj = startDate.add(value, "weeks").format("YYYY-MM-DD");
  } else if (unit === BillingType.Month) {
    obj = startDate.add(value, "months").format("YYYY-MM-DD");
  } else if (unit === BillingType.Year) {
    obj = startDate.add(value, "years").format("YYYY-MM-DD");
  } else if (unit === BillingType.OneTime) {
    obj = startDate.format("YYYY-MM-DD");
  } else if (unit === BillingType.Forever) {
    return BillingType.Forever;
  }

  return obj;
}
